/**
 * 配送ステータスリスト
 */
export const DELIVERY_STATUS_TYPE = [
  '未配送',
  '配送処理完了',
] as const;

/**
 * 配送ステータス
 */
export type DeliveryStatusType = typeof DELIVERY_STATUS_TYPE[number];
